import React from 'react'
import { WarningAmberRounded } from '@mui/icons-material'
import PropTypes from 'prop-types'
import Colors from 'utils/Colors'
import ErrorMessage from 'components/ErrorMessage'
import DashboardCard from '../DashboardCard'

const DataLoadErrorCard = (props) => {
  const { actionCallback, message, title } = props
  return (
    <DashboardCard title={title}>
      <ErrorMessage
        actionCallback={actionCallback}
        message={message}
        buttonText="Recarregar dados"
        IconComponent={WarningAmberRounded}
        color={Colors.dataLoadErrorIcon}
        iconSize="3rem"
        fontSize="14px"
        buttonVariant="text"
      />
    </DashboardCard>
  )
}

DataLoadErrorCard.propTypes = {
  actionCallback: PropTypes.func,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

DataLoadErrorCard.defaultProps = {
  actionCallback: null,
}

export default DataLoadErrorCard
